import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";
import {
  LeaveStatus,
  WorkFromHomeStatus,
} from "../../../redux/stcoTools/stcoToolsType";

type AppProps = {
  leaveStatus: LeaveStatus;
  workFromHomeStatus: WorkFromHomeStatus;
  isApplyWFHApplyPresent: boolean;
  activeAction: string;
  setActiveAction: React.Dispatch<React.SetStateAction<string>>;
};
const CurrentYearLeavesAndWFHStatus = ({
  leaveStatus,
  workFromHomeStatus,
  isApplyWFHApplyPresent,
  setActiveAction,
  activeAction,
}: AppProps) => {
  // const [activeAction, setActiveAction] = useState("leave");
  const options = {
    tooltip: {
      trigger: "item",
      formatter: "{b}",
    },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      orient: "vertical",
      right: "10%",
      top: "middle",
      padding: [0, -25, 0, 20],
      itemGap: 30,
      selectedMode: false,
    },
    itemStyle: {
      color: "rgba(0, 0, 0, 0.2)", // Adjust the color and opacity
    },
    padAngle: 5,
    series: [
      {
        type: "pie",

        radius: ["0%", "40%"],
        center: ["26%", "50%"],
        label: {
          show: false,
          position: "none",
        },

        data: [
          {
            value: leaveStatus?.approved_leave,
            name: `Approved Leaves ${leaveStatus?.approved_leave}`,
            itemStyle: { color: "#91cc75" },
          },
          {
            value: leaveStatus?.pending_leave,
            name: `Pending Leaves ${leaveStatus?.pending_leave}`,
            itemStyle: { color: "#fac858" },
          },
          {
            value: leaveStatus?.rejected_leave,
            name: `Rejected ${leaveStatus?.rejected_leave}`,
            itemStyle: { color: "#ee6666" },
          },
          {
            value: leaveStatus?.balance_leave,
            name: `Leave Balance ${
              leaveStatus?.balance_leave -
                (leaveStatus?.approved_leave -
                  leaveStatus?.full_time_unpaid_approved_leave +
                  leaveStatus?.pending_leave) <
              0
                ? 0
                : leaveStatus?.balance_leave -
                  (leaveStatus?.approved_leave -
                    leaveStatus?.full_time_unpaid_approved_leave +
                    leaveStatus?.pending_leave)
            }`,
            itemStyle: { color: "#5470c6" },
          },
        ],
      },
    ],
  };

  ////wfh
  const optionsWFH = {
    tooltip: {
      trigger: "item",
      formatter: "{b}",
    },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      orient: "vertical",
      right: "10%",
      top: "middle",
      padding: [0, -25, 0, 20],
      itemGap: 30,
      selectedMode: false,
    },
    itemStyle: {
      color: "rgba(0, 0, 0, 0.2)", // Adjust the color and opacity
    },
    padAngle: 5,
    series: [
      {
        type: "pie",

        radius: ["0%", "40%"],
        center: ["26%", "50%"],
        label: {
          show: false,
          position: "none",
        },

        data: [
          {
            value: workFromHomeStatus?.approved_wfh,
            name: `Approved WFH ${workFromHomeStatus?.approved_wfh}`,
            itemStyle: { color: "#91cc75" },
          },
          {
            value: workFromHomeStatus?.pending_wfh,
            name: `Pending WFH ${workFromHomeStatus?.pending_wfh}`,
            itemStyle: { color: "#fac858" },
          },
          {
            value: workFromHomeStatus?.rejected_wfh,
            name: `Rejected ${workFromHomeStatus?.rejected_wfh}`,
            itemStyle: { color: "#ee6666" },
          },
          {
            value: workFromHomeStatus?.balance_wfh,
            name: `WFH Balance ${
              workFromHomeStatus?.balance_wfh -
                (workFromHomeStatus?.approved_wfh +
                  workFromHomeStatus?.pending_wfh) <
              0
                ? 0
                : workFromHomeStatus?.balance_wfh -
                  (workFromHomeStatus?.approved_wfh +
                    workFromHomeStatus?.pending_wfh)
            }`,
            itemStyle: { color: "#5470c6" },
          },
        ],
      },
    ],
  };
  return (
    <>
      <div style={{ position: "relative" }}>
        <div className="d-flex align-items-center justify-content-between">
          <p style={{ fontSize: "18px", fontWeight: 600 }} className="p-3 m-0">
            {activeAction === "leave"
              ? "Current Year Leaves"
              : "Current Year WFH"}
          </p>
          <div style={{ zIndex: 999 }}>
            <button
              className={`btn ${!isApplyWFHApplyPresent ? "mr-3" : ""}`}
              style={{
                zIndex: 8888,
                cursor: "pointer",
                backgroundColor:
                  activeAction === "leave" ? "rgb(255, 246, 245)" : "#e1e9f0",
                border:
                  activeAction === "leave"
                    ? "1px solid rgb(221, 68, 51)"
                    : "1px solid rgb(191, 203, 225)",
                color: activeAction === "leave" ? "rgb(221, 68, 51)" : "black",
              }}
              onClick={() => {
                setActiveAction("leave");
              }}
            >
              Leave
            </button>
            {isApplyWFHApplyPresent ? (
              <button
                className="ml-1 mr-3 btn"
                style={{
                  zIndex: 8888,
                  cursor: "pointer",
                  backgroundColor:
                    activeAction === "wfh" ? "rgb(255, 246, 245)" : "#e1e9f0",
                  border:
                    activeAction === "wfh"
                      ? "1px solid rgb(221, 68, 51)"
                      : "1px solid rgb(191, 203, 225)",
                  color: activeAction === "wfh" ? "rgb(221, 68, 51)" : "black",
                }}
                onClick={() => {
                  setActiveAction("wfh");
                }}
              >
                WFH
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        {activeAction === "leave" && (
          <>
            {" "}
            <ReactEcharts
              option={options}
              style={{
                height: 463,
                position: "absolute",
                width: "100%",
                top: "-40px",
                zIndex: 10,
              }}
            />
            <div
              style={{
                position: "absolute",
                // width: "180px",
                left: "7%",
                top: "294px",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "16px", fontWeight: "400" }}>
                  Total Leave Balance
                </div>
                <div
                  className="ml-2"
                  style={{ color: "black", fontSize: "16px" }}
                >
                  {leaveStatus?.balance_leave -
                    (leaveStatus?.approved_leave -
                      leaveStatus?.full_time_unpaid_approved_leave +
                      leaveStatus?.pending_leave) <
                  0
                    ? 0
                    : leaveStatus?.balance_leave -
                      (leaveStatus?.approved_leave -
                        leaveStatus?.full_time_unpaid_approved_leave +
                        leaveStatus?.pending_leave)}
                  /{leaveStatus?.balance_leave}
                </div>
              </div>
            </div>
          </>
        )}
        {activeAction === "wfh" && (
          <>
            {" "}
            <ReactEcharts
              option={optionsWFH}
              style={{
                height: 463,
                position: "absolute",
                width: "100%",
                top: "-40px",
              }}
            />
            <div
              style={{
                position: "absolute",
                // width: "180px",
                left: "7%",
                top: "294px",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "16px", fontWeight: "400" }}>
                  Total WFH Balance
                </div>
                <div
                  className="ml-2"
                  style={{ color: "black", fontSize: "16px" }}
                >
                  <>
                    {workFromHomeStatus?.balance_wfh -
                      (workFromHomeStatus?.approved_wfh +
                        workFromHomeStatus?.pending_wfh) <
                    0
                      ? 0
                      : workFromHomeStatus?.balance_wfh -
                        (workFromHomeStatus?.approved_wfh +
                          workFromHomeStatus?.pending_wfh)}
                    /{workFromHomeStatus?.balance_wfh}
                  </>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CurrentYearLeavesAndWFHStatus;
